import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContextMenuService {
  hideMenu: Subject<void>;

  constructor() {
    this.hideMenu = new Subject();
  }
}
